














import './KisweFormGroup.scss'
import { defineComponent } from '@vue/composition-api'
import useFlexbox from '../../../compositions/flexbox'
import useGrid from '../../../compositions/grid'
import { FlexboxAlignItems } from '../../../types/flexbox'

export default defineComponent({
  name: 'KisweFormGroup',
  props: {
    ...useFlexbox({ align: FlexboxAlignItems.FlexStart }).props,
    ...useGrid().props
  }
})
